module.exports = __webpack_public_path__ + "img/23.84ff3f19.png";